function alaskaPacificSwap() {
    const bundleItems = document.querySelectorAll('h3.bundle-item-title');
    bundleItems.forEach(item => {
      if (item.textContent.includes("Wild Alaska King Salmon")) {
        item.textContent = "Wild Pacific King Salmon";
      }
    });
  }
  
  function getOrCreateContainsInput() {
    let input = $('input[name="properties[Contains]"], input[name="properties[contains]"]').first();
  
    if (!input.length) {
      input = $('<input>')
        .attr({ type: 'hidden', name: 'properties[Contains]' })
        .appendTo('#custom-subscription-forms');
    } else {
      // Standardize to capital "Contains"
      input.attr('name', 'properties[Contains]');
    }
  
    return input;
  }
  
  function initSlides() {
    if ($(window).width() <= 751) {
      if (
        !$(".all-products > div").hasClass("slick-initialized") &&
        $(".all-products > div .bundle-item").length > 4
      ) {
        $(".all-products > div").slick({
          dots: false,
          infinite: false,
          arrows: false,
          slidesToShow: 4,
        });
      }
      $(".item-container").each(function () {
        if (!$(this).hasClass("slick-initialized")) {
          if (
            !$(this).hasClass("predefined") ||
            $(this).find(".item-card").length > 1
          ) {
            $(this).slick({
              dots: false,
              centerMode: false,
              variableWidth: false,
              infinite: false,
              arrows: false,
              slidesToShow: 1.2,
            });
          }
        }
      });
    } else {
      $(".fixed-atc").show();
      if ($(".step-carousel-container").hasClass("slick-initialized")) {
        $(".step-carousel-container").slick("unslick");
      }
      if ($(".all-products > div").hasClass("slick-initialized")) {
        $(".all-products > div").slick("unslick");
      }
      $(".item-container").each(function () {
        if ($(this).hasClass("slick-initialized")) {
          $(this).slick("unslick");
        } else {
        }
      });
    }
  }
  var loaded = false;
  $(".js-edit-product").on("click", function () {
    var checkExist = setInterval(function () {
      if ($("#custom-subscription-forms").length) {
        loadCYO();
        clearInterval(checkExist);
      }
    }, 100);
  });
  
  function loadCYO() {
    if ($("#custom-subscription-forms").length > 0) {
      var pTitle = $("#custom-subscription-forms").attr("data-product-title");
      var pHandle = $("#custom-subscription-forms").attr("data-product-handle");
      var pId = $("#custom-subscription-forms").attr("data-variant-id");
      var pType = $("#custom-subscription-forms").attr("data-page-type");
      var pUrl = "/pages/feed";
      var allBundlesLimit = 0;
      var preDef = false;
      var containsArray = [];
  
      $.get("/products/" + pHandle + ".json", function (prod) {
        if (
          prod["product"]["template_suffix"].includes("predefined") ||
          prod["product"]["title"].includes("Wild Seafood Favorites Box")
        ) {
          preDef = true;
        }
        var script = document.createElement("script");
        script.onload = function () {
          if (loaded) {
            $(".spRem").each(function (i, obj) {
              obj.remove();
            });
          }
          //
  
          //var allBundles = JSON.parse(htmlDoc.getElementById('feed-data').innerHTML.replace(/,([^,]*)$/,'\$1') + ']');
          var allBundles = bundle_groups;
          var metadata = allBundles.find((x) => x.variant == pId);
  
          if (metadata && metadata["bundle_data"]["bundle_groups"]) {
            //todo: get qty limits for everything
            for (bundleGroup in metadata["bundle_data"]["bundle_groups"]) {
              var subProducts = {};
              var grpName = metadata["bundle_data"]["bundle_groups"][bundleGroup][
                "info"
              ]["name"]
                .replaceAll(" ", "-")
                .replaceAll("&", "and");
              allBundlesLimit +=
                metadata["bundle_data"]["bundle_groups"][bundleGroup]["info"][
                  "qty"
                ];
              $("#custom-subscription-forms").prepend(
                '<div id="bg-' + grpName + '"></div>'
              );
              const itemsFromMetadata =
                metadata["bundle_data"]["bundle_groups"][bundleGroup]["info"][
                  "items"
                ];
              const sortedItemsFromMetadata = itemsFromMetadata.sort((a, b) =>
                a.display_order > b.display_order ? 1 : -1
              );
  
  
              for (item in sortedItemsFromMetadata) {
                var totalLimit =
                  metadata["bundle_data"]["bundle_groups"][bundleGroup]["info"]["qty"];
                var spHandle =
                  metadata["bundle_data"]["bundle_groups"][bundleGroup]["info"]["items"][item]["handle"];
                var spQty =
                  metadata["bundle_data"]["bundle_groups"][bundleGroup]["info"]["items"][item]["qty"];
                var spLocationId =
                  metadata["bundle_data"]["bundle_groups"][bundleGroup]["info"]["items"][item]["location_id"];
                var spInventoryId =
                  metadata["bundle_data"]["bundle_groups"][bundleGroup]["info"]["items"][item]["inventory_id"];
  
  
                $.ajax({
                  async: false,
                  url: "/products/" + spHandle,
                  dataType: "json",
                  success: function (product) {
                    subProducts[product["product"]["handle"]] = {
                      "product-image": product["product"]["image"]["src"],
                      "product-title": product["product"]["title"],
                      "product-inventory-id": spInventoryId,
                      "product-location-id": spLocationId,
                      "product-sku": product["product"]["variants"][0]["sku"],
                      "product-qty": spQty,
                      "product-bundle-qty": totalLimit,
                    };
                  },
                });
                //jQuery.getJSON('/products/' + spHandle, function(product)  );
              }
  
  
              // console.log(subProducts);
  
              var subProductHTML =
                "<p class='spRem' style='margin-bottom:0;'><b style='font-size:17px;'>Your box contains:</b></p><p class='needs-more-" +
                grpName +
                "' style='display:none;'></p><div class='item-container'>";
              var subProductCounter = 0;
  
              for (subProduct in subProducts) {
                var sp = subProducts[subProduct];
                containsArray.push(
                  sp["product-qty"] + "x " + sp["product-title"]
                );
                subProductHTML +=
                  "<div class='item-card card-" + subProductCounter + "'>";
                subProductHTML += "<div>";
                subProductHTML +=
                  "<img src='" +
                  sp["product-image"] +
                  "' style='display:inline-block;' width='100%'>";
                subProductHTML +=
                  "<div style='display:inline-block;width:100%;'><p style='font-size:17px;margin-bottom:0;line-height:1.2em'>" +
                  sp["product-title"];
                subProductHTML +=
                  "</p><a href='/products/" +
                  subProduct +
                  "' target='_blank'><small>View Details</small></a></div></div><div class='qty-container' data-item-max='" +
                  sp["product-qty"];
                subProductHTML +=
                  "' data-location-id='" +
                  sp["product-location-id"] +
                  "' data-inventory-id='" +
                  sp["product-inventory-id"];
                subProductHTML +=
                  "' data-item-bundle-max='" +
                  sp["product-bundle-qty"] +
                  "' data-sku='" +
                  sp["product-sku"];
                subProductHTML +=
                  "' data-product-title='" +
                  sp["product-title"] +
                  "' data-group-name='" +
                  grpName +
                  "'>";
                subProductHTML +=
                  "<span class='minus' style='cursor:pointer;position:absolute;left:5%;'>-</span>";
                subProductHTML +=
                  "<span class='item-qty item-qty-" +
                  grpName +
                  "'>0</span><span class='plus' style='cursor:pointer;position:absolute;right:5%;'>+</span></div></div>";
                subProductCounter++;
              }
              subProductHTML += "</div><div style='clear:both;'></div>";
              if (!preDef) {
                let includedSKUsInput = $('input[name="properties[_includedSKUs]"]');
            
                if (!includedSKUsInput.length) {
                    includedSKUsInput = $('<input>', {
                        type: 'hidden',
                        id: 'iSkus',
                        name: 'properties[_includedSKUs]',
                        value: ''
                    }).insertAfter(getOrCreateContainsInput());
                } else {
                    includedSKUsInput.attr('id', 'iSkus');
                }
            
                $("#bg-" + grpName).prepend(subProductHTML);
                loaded = true;
              } else {
                // Ensure 'Contains' input exists and is standardized
                let containsInput = getOrCreateContainsInput();
                containsInput.val(containsArray.join(", "));
              
                // Remove existing _includedSKUs if present
                $('input[name="properties[_includedSKUs]"]').remove();
              }
              
              if (!preDef) {
                $("button[type=submit]").first().prop("disabled", true);
              }
  
              //counter variable 0. remove all hidden bundles. loop through each qty container, get location and inventory id. then recreate hidden bundles
            }
  
            $('input[type="hidden"][name^="properties[_bundle_item"').each(
              function () {
                $(this).addClass("hidden-bundle");
                // console.log($(this));
                var bundleItemData = JSON.parse(
                  $(this)
                    .val()
                    .replace("location_id", '"location_id"')
                    .replace("inventory_id", '"inventory_id"')
                );
                // console.log(bundleItemData);
                var itemQty = $(
                  '[data-location-id="' +
                    bundleItemData["location_id"] +
                    '"][data-inventory-id="' +
                    bundleItemData["inventory_id"] +
                    '"] .item-qty'
                );
                itemQty.html(parseInt(itemQty.html()) + 1);
              }
            );
  
            $(".item-container .btn").on("click", function () {
              $(this).addClass("clicked");
            });
  
  
  
  
  
            // // Disables update button when incorrect number of items in box
            if ($(".hidden-bundle").length < allBundlesLimit) {
              $(".rc_btn.text-uppercse.title-bold").prop("disabled", true);
              let itemsNeeded = allBundlesLimit - $(".hidden-bundle").length;
              generateFlag(itemsNeeded, pTitle);
            } 
            else {
              $(".rc_btn.text-uppercse.title-bold").prop("disabled", false);
              let itemsNeeded = allBundlesLimit - $(".hidden-bundle").length;
              generateFlag(itemsNeeded, pTitle);
            }
  
  
  
  
  
            $(".minus").on("click", function () {
                var itemLimit = parseInt($(this).parent().attr("data-item-max"));
                var groupName = $(this).parent().attr("data-group-name");
                var totalLimit = parseInt($(this).parent().attr("data-item-bundle-max"));
                var currentAmount = 0;
              
                $(this)
                  .closest(".item-container")
                  .find(".item-qty-" + groupName)
                  .each(function () {
                    currentAmount += parseInt($(this).html());
                  });
              
                var currentItemQtyEl = $(this).parent().find(".item-qty-" + groupName);
                var currentItemQty = parseInt(currentItemQtyEl.html());
              
                if (currentItemQty > 0) {
                  currentItemQtyEl.html(currentItemQty - 1);
              
                  $(".hidden-bundle").remove();
              
                  var skuArray = {};
                  if ($("#iSkus").val() !== "") {
                    skuArray = JSON.parse($("#iSkus").val());
                  }
              
                  var sku = $(this).parent().attr("data-sku");
                  if (skuArray[sku] && skuArray[sku] > 1) {
                    skuArray[sku]--;
                  } else {
                    delete skuArray[sku];
                  }
              
                  $("#iSkus").val(JSON.stringify(skuArray));
              
                  // Update "Contains" property
                  var containsInput = $('input[name="properties[Contains]"], input[name="properties[contains]"]').first();
                  if (!containsInput.length) {
                    containsInput = $('<input>', {
                      type: "hidden",
                      name: "properties[Contains]",
                    }).appendTo("#custom-subscription-forms");
                  } else {
                    containsInput.attr("name", "properties[Contains]");
                  }
              
                  var contains = containsInput.val().split(",").map(val => val.trim());
                  var newContainsArray = [];
              
                  contains.forEach(val => {
                    var [qty, title] = val.split("x ");
                    qty = parseInt(qty);
              
                    if (title === $(this).parent().attr("data-product-title")) {
                      if (qty > 1) {
                        newContainsArray.push(qty - 1 + "x " + title);
                      }
                    } else if (title) {
                      newContainsArray.push(qty + "x " + title);
                    }
                  });
              
                  containsInput.val(newContainsArray.join(", "));
              
                  // Rebuild bundle item inputs
                  var lineItemNo = 0;
                  $(this)
                    .closest("#custom-subscription-forms")
                    .find(".item-qty")
                    .each(function () {
                      var updatedItemQty = parseInt($(this).html());
                      var locationId = $(this).parent().attr("data-location-id");
                      var inventoryId = $(this).parent().attr("data-inventory-id");
              
                      for (var i = 0; i < updatedItemQty; i++) {
                        var lineItemHTML =
                          "<input type='hidden' name='properties[_bundle_item_" +
                          lineItemNo +
                          "]' value='{location_id:" +
                          locationId +
                          ",inventory_id:" +
                          inventoryId +
                          "}' class='hidden-bundle'/>";
              
                        lineItemNo++;
              
                        $(lineItemHTML).insertAfter(containsInput);
                      }
                    });
              
                  // Update buttons and flags
                  if ($(".hidden-bundle").length < allBundlesLimit) {
                    $(".rc_btn.text-uppercse.title-bold").prop("disabled", true);
                    let itemsNeeded = allBundlesLimit - $(".hidden-bundle").length;
                    generateFlag(itemsNeeded, pTitle);
                  } else {
                    $(".rc_btn.text-uppercse.title-bold").prop("disabled", false);
                    generateFlag(0, pTitle);
                  }
                }
              });
              
  
  
  
            $(".plus").on("click", function () {
                var $parent = $(this).parent();
                var itemLimit = parseInt($parent.attr("data-item-max"));
                var groupName = $parent.attr("data-group-name");
                var totalLimit = parseInt($parent.attr("data-item-bundle-max"));
                var productTitle = $parent.attr("data-product-title");
              
                var currentAmount = 0;
                var currentAmount2 = parseInt($parent.find(".item-qty-" + groupName).html());
              
                $parent.closest('.item-container').find(".item-qty-" + groupName).each(function () {
                  currentAmount += parseInt($(this).html());
                });
              
                // Increment only if within limits
                if (currentAmount2 < itemLimit && currentAmount2 < totalLimit && currentAmount < totalLimit) {
                  $parent.find(".item-qty-" + groupName).html(currentAmount2 + 1);
              
                  $(".hidden-bundle").remove();
              
                  var skuArray = {};
                  if ($("#iSkus").val() !== "") {
                    skuArray = JSON.parse($("#iSkus").val());
                  }
              
                  var sku = $parent.attr("data-sku");
                  skuArray[sku] = (skuArray[sku] || 0) + 1;
                  $("#iSkus").val(JSON.stringify(skuArray));
              
                  let containsInput = getOrCreateContainsInput();
                  let contains = containsInput.val() ? containsInput.val().split(",") : [];
              
                  let updated = false;
                  let newContainsArray = [];
              
                  for (let val of contains) {
                    let [qty, title] = val.split("x ");
                    qty = parseInt(qty.trim());
                    if (title === productTitle) {
                      newContainsArray.push((qty + 1) + "x " + title);
                      updated = true;
                    } else if (title) {
                      newContainsArray.push(qty + "x " + title);
                    }
                  }
              
                  if (!updated) {
                    newContainsArray.push("1x " + productTitle);
                  }
              
                  containsInput.val(newContainsArray.join(", "));
              
                  var lineItemNo = 0;
                  $(".item-qty").each(function () {
                    var updatedItemQty = parseInt($(this).html());
                    var locationId = $(this).parent().attr("data-location-id");
                    var inventoryId = $(this).parent().attr("data-inventory-id");
              
                    $(".needs-more-" + groupName).html("");
                    $("button[type=submit]").first().attr("disabled", false);
              
                    for (var i = 0; i < updatedItemQty; i++) {
                      var lineItemHTML = `<input type='hidden' name='properties[_bundle_item_${lineItemNo}]' value='{location_id:${locationId},inventory_id:${inventoryId}}' class='hidden-bundle'/>`;
                      lineItemNo++;
                      $(lineItemHTML).insertAfter(containsInput);
                    }
                  });
              
                  if ($(".hidden-bundle").length < totalLimit) {
                    $(".rc_btn.text-uppercse.title-bold").prop("disabled", true);
                  } else {
                    $(".rc_btn.text-uppercse.title-bold").prop("disabled", false);
                  }
              
                  let itemsNeeded = totalLimit - $(".hidden-bundle").length;
                  generateFlag(itemsNeeded, $("#custom-subscription-forms").attr("data-product-title"));
                }
              });
              
              // Helper function (ensure it's included in your script)
              function getOrCreateContainsInput() {
                let containsInput = $('input[name="properties[Contains]"], input[name="properties[contains]"]').first();
                if (!containsInput.length) {
                  containsInput = $('<input>')
                    .attr({ type: 'hidden', name: 'properties[Contains]' })
                    .appendTo('#custom-subscription-forms');
                } else {
                  containsInput.attr('name', 'properties[Contains]');
                }
                return containsInput;
              }
  
            initSlides();
  
            //get
            //console.log(subProducts);
            //console.log(metadata["bundle_data"]["bundle_groups"][0]["info"]["items"]);
          }
        }; //end of 2nd function
  
        script.src = "//www.sizzlefish.com/cdn/shop/t/522/assets/bundle_settings.js?v=54993548332312474141782909032";
        document.body.appendChild(script);
      }); //end of first get function
    }
  }
  
  
  
  loadCYO();
  $("#sub-btn").click(function () {
    $("#sub-btn").html("processing...");
    $("#sub-btn").prop("disabled", true);
    var nVal = $("#iSkus")[0].value.replaceAll('"', "");
    $("#iSkus").val(nVal);
    $("#sub-btn-hdn").click();
  });
  $(".rc_option__selector").on("change", function () {
    $("#custom-subscription-forms").empty();
    $("#iSkus").val("");
    $(".hidden-bundle").remove();
    $('input[name="properties[Contains]"], input[name="properties[contains]"]').val("");
    var varId = $("#shopify_variant_id").val();
    $("#custom-subscription-forms").attr("data-variant-id", varId);
    loadCYO();
  });
  
  $("#product_options_container")
    .find("select")
    .first()
    .on("change", function () {
      var val = this.value;
      $("#custom-subscription-forms").empty();
      $("#iSkus").val("");
      $(".hidden-bundle").remove();
      $('input[name="properties[Contains]"], input[name="properties[contains]"]').val("");
      $("#shopify_variant_id option").each(function () {
        if (this.innerHTML.includes(val)) {
          var varId = this.value;
          $("#custom-subscription-forms").attr("data-variant-id", varId);
          loadCYO();
        }
      });
    });
  
  
  
  
  /**
   * Helper function to generate and display flags
   * 
   * Container for flags = #bg-Add-Items-to-Your-Box
   */ 
  function generateFlag(itemsNeeded, pTitle) {
    if (itemsNeeded == 0) {
      // for success flag 
      var logoUrl = 'https://cdn.shopify.com/s/files/1/0250/8353/files/Approve.svg?v=1704472558'; // Warning_1 SVG
      var flagHtml = `
      <div class="flag-container" 
           style="
              display: flex; 
              align-items: center; 
              justify-content: start;
              background-color: #4bb543;
              padding: 5px 0;
              border-radius: 5px;
              margin: 10px 0px;
              padding: 10px 0px;
              ">
          <img src="${logoUrl}" alt="Logo" style="height: 25px; width: auto; margin-right: 10px;">
          <div style="color: white;">
              <b>Your box is full! Please remove items if you wish to add more.</b>.
          </div>
      </div>`;
      
      // Remove existing flag (if any)
      $('.flag-container').remove();
      $('#bg-Add-Items-to-Your-Box .item-container').after(flagHtml);
    } 
    else {
      // for warning flag
      var logoUrl = 'https://cdn.shopify.com/s/files/1/0250/8353/files/Warning_1.svg?v=1704472863'; // Warning_1 SVG 
      var flagHtml = `
      <div class="flag-container" 
           style="
              display: flex; 
              align-items: center; 
              justify-content: start;
              background-color: #fa3d5c;
              padding: 5px 0;
              border-radius: 5px;
              margin: 10px 0px;
              padding: 10px 0px;
              ">
          <img src="${logoUrl}" alt="Logo" style="height: 25px; width: auto; margin-right: 10px;">
          <div style="color: white;">
              <b>Please add ${itemsNeeded} more to complete your ${pTitle}</b>.
          </div>
      </div>`;
      
      // Remove existing flag (if any)
      $('.flag-container').remove();
      $('#bg-Add-Items-to-Your-Box .item-container').after(flagHtml);
  
      // $(".needs-more-Add-Items-to-Your-Box").show().html('Please add <b style="color:red;">' + itemsNeeded + "</b> more to complete your <b> " + pTitle + "</b>.");
  
    }
  
  }